import { useIntl } from 'react-intl'
import styled from 'styled-components'

import Label from 'LuxKit/Label'

const StatusLabelWithPrintBorder = styled(Label)`
  @media print {
    &.kind-tertiary {
      border: 1px solid ${props => props.theme.palette.highlight.primary.lightBackground};
    }
  }
`

interface Props {
  className?: string
}

function JustAddedLabel({ className }: Props) {
  const intl = useIntl()
  return (
    <StatusLabelWithPrintBorder kind="tertiary" variant="highlight" className={className}>
      {intl.formatMessage({
        id: 'JJWsod_bEmWKTTyK6cw3',
        defaultMessage: 'Just added',
        description: 'Label indicating a trip item was recently added in the trip planner',
      })}
    </StatusLabelWithPrintBorder>
  )
}

export default JustAddedLabel
